import BulletList from '@tiptap/extension-bullet-list';
import { makeSyncMenu, makeToggleListCommand } from './_list_helpers';

const syncMenu = makeSyncMenu('bulletList', 'unordered');

export default [
  BulletList.extend({
    addCommands: makeToggleListCommand('toggleBulletList'),
    onSelectionUpdate: syncMenu,
    onTransaction({ editor }) {
      syncMenu({ editor });
    },
  }),
];
